import React, { useEffect, useMemo, useState } from 'react';
import { Box, Modal, Fade, Grid, Button, IconButton, MenuItem, Radio, RadioGroup, FormControl, FormControlLabel, TextField, Select, Stack, SelectChangeEvent } from '@mui/material';
import { generateClient } from 'aws-amplify/api';
import { listIndustryMasters, industryMastersBySubCategory, industryMastersByItem, industryMastersByItemFlg } from '../../graphql/queries';
import swal from 'sweetalert2';
import CloseIcon from '@mui/icons-material/Close';
import SearchIcon from '@mui/icons-material/Search';
import styled from '@emotion/styled';
import "./SelectIndustryModal.css";
import DropDownIcon from '@mui/icons-material/ArrowDropDown';
import HelpIcon from '@mui/icons-material/Help';
import { industryData } from './IndustryData';
import { useNavigate } from 'react-router-dom';
import { sessionDisconnectedCheck } from 'shared/sessionDisconnectedCheck';
import { SystemErrorTitle, SystemErrorMsg } from '../../constants';
import { BackdropLoading } from "shared/backdropLoading";

interface OwnProps {
    isOpen: boolean,
    handleCloseModal: any,
    industryData: industryData,
    yearEdition: any,
    onConfirm: (industryData: industryData) => void;
}

const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    maxWidth: '70%',
    maxHeight: '95%',
    width: '70%',
    minWidth: '30rem',
    height: '90vh',
    bgcolor: 'background.paper',
    boxShadow: 24,
    textAlign: 'center',
    borderRadius: '2rem',
};

const ModalLabel = styled(Box)(({ }) => ({
    position: 'relative',
    backgroundColor: '#41DBCE',
    fontSize: '1.2rem',
    color: '#FFFFFF',
    height: '2rem',
    paddingTop: '0.5rem',
    borderRadius: '15px 15px 0 0',
    textAlign: 'left',
    paddingLeft: '1rem',
}));

const SearchGrid01 = styled(Grid)(({ }) => ({
    backgroundColor: '#f5f5f5',
    color: '#41DBCE;',
    textAlign: 'center',
    fontSize: '1.1rem',
    fontWeight: 'bold',
    height: '20rem',
    lineHeight: '2.3rem',
    padding: '0.5rem',
    width: '43%',
    minWidth: '11rem',
    marginTop: '1rem',
}));

const SearchGrid02 = styled(Grid)(({ }) => ({
    backgroundColor: '#f5f5f5',
    color: '#41DBCE;',
    textAlign: 'center',
    fontSize: '1.1rem',
    fontWeight: 'bold',
    height: '20rem',
    lineHeight: '2.3rem',
    padding: '0.5rem',
    width: '43%',
    minWidth: '11rem',
    marginTop: '1rem',
}));

const TextFieldBox = styled(Box)(({ }) => ({
    textAlign: 'center',
    fontSize: '1.2rem',
    color: '#595959',
    display: 'flex',
    gap: 0,
    alignItems: 'flex-start'
}));

const TextFieldLabel = styled(Grid)(({ }) => ({
    textAlign: 'center',
    backgroundColor: '#595959',
    color: '#FFFFFF',
    fontSize: 'clamp(0.6rem, 1.3vw, 1.0rem)',
    height: '2rem',
}));

const TextFieldForm = styled(Grid)(({ }) => ({
    backgroundColor: '#FFFFFF',
    overflow: 'visible',
    height: '2rem',
}));

const DataInputForm = styled(TextField)(({ }) => ({
    '& .MuiOutlinedInput-root': {
        '& fieldset': {
            border: 'none',
        },
        '&:hover fieldset': {
            border: 'none',
        },
        '&.Mui-focused fieldset': {
            border: 'none',
        },
        height: '2rem',
    }
}))

const AppliedButton = styled(Button)(({ }) => ({
    backgroundColor: '#01CFBE',
    color: '#FFFFFF',
    textAlign: 'center',
    fontSize: '1.0rem',
    fontWeight: 'bold',
    height: '2.2rem',
    width: '10rem',
    borderRadius: '100rem',
}));

const Comparisonbutton = styled(Button)(({ }) => ({
    backgroundColor: '#F2F2F2',
    color: '#595959',
    textAlign: 'left',
    fontSize: '1rem',
    padding: '0rem',
    height: '2.0rem',
    width: '7rem',
    borderRadius: '100rem',
}));

const HelpButton = styled(Button)(({ }) => ({
    backgroundColor: '#F2F2F2',
    color: '#595959',
    textAlign: 'center',
    fontSize: 'clamp(0.5rem, 1.1vw, 1rem)',
    fontWeight: 'bold',
    height: '2.3rem',
    width: '10%',
    borderRadius: '100rem',
    marginTop: '1rem'
}));

const screenId = "U021"

const SelectIndustryModal = (props: OwnProps) => {
    const navigate = useNavigate();
    const { isOpen, handleCloseModal, industryData, yearEdition, onConfirm } = props
    const [open, setOpen] = React.useState(isOpen);
    const [selectedL, setSelectedL] = useState("")
    const [selectedM, setSelectedM] = useState("")
    const [selectedS, setSelectedS] = useState("")
    const [selectedF, setSelectedF] = useState("")
    const [mainCategoryList, setMainCategoryList] = useState<any[]>([])
    const [subCategoryList, setSubCategoryList] = useState<any[]>([])
    const [subSubCategoryList, setSubSubCategoryList] = useState<any[]>([])
    const [detailLevelList, setDetailLevelList] = useState<any[]>([])
    const [mainCategory, setMainCategory] = useState("")
    const [subCategory, setSubCategory] = useState("")
    const [item, setItem] = useState("")
    const [itemFlg, setItemFlg] = useState("")
    const [scaleCode, setScaleCode] = useState("")
    const [searchScaleCode, setSearchScaleCode] = useState("") // プルダウン検索用の規模コード
    const [classification, setClassification] = useState("")
    const [selectedSearch, setSelectedSearch] = useState("")
    const [text, setText] = useState("")
    const [filteredResult, setFilteredResult] = useState<any[]>([])
    const [selectedRadio, setSelectedRadio] = useState('option1')
    const [loading, setLoading] = useState<boolean>(false);
    // const nowDate = Math.floor(Date.now() / 1000)
    const nowDate = useMemo(() => {
        const today = new Date();
        const year = today.getFullYear();
        const month = String(today.getMonth() + 1).padStart(2, '0');
        const day = String(today.getDate()).padStart(2, '0');
        const yyyymmddStr = `${year}${month}${day}`;
        const yyyymmddNum = Number(yyyymmddStr);
        return yyyymmddNum;
    }, []);

    useEffect(() => {
        if (!isOpen) return;
        const getCategoryList = async () => {
            // セッションの有効性確認
            if (await sessionDisconnectedCheck(screenId, "getCategoryList", yearEdition, navigate)) {
                return
            }
            try {
                let allItems: any[] = [];
                let nextToken: string | null = null;
                do {
                    const client = generateClient();
                    const result: any = await client.graphql({
                        query: industryMastersBySubCategory,
                        variables: {
                            subCategory: 'blank',
                            nextToken: nextToken,
                            filter: {
                                and:
                                    [
                                        { startDateTime: { le: nowDate } },
                                        { endDateTime: { ge: nowDate } },
                                        { mainCategory: { ne: "" } }
                                    ]
                            },
                            limit: 1000
                        },
                    });
                    const items = result.data?.industryMastersBySubCategory?.items || [];
                    nextToken = result.data?.industryMastersBySubCategory?.nextToken || null;
                    allItems = allItems.concat(items)
                } while (nextToken);
                allItems.sort((a: any, b: any) => {
                    //　大分類でソート
                    if (a.mainCategory !== b.mainCategory) {
                        return a.mainCategory.localeCompare(b.mainCategory);
                    }
                    // 大分類が同じ場合は規模コードでソート
                    if (a.scaleCode === "blank") return -1;
                    if (b.scaleCode === "blank") return 1;
                    return a.scaleCode.localeCompare(b.scaleCode);
                });
                setMainCategoryList(allItems)
            } catch (err) {
                navigate("/Error", { state: { title: SystemErrorTitle, message: SystemErrorMsg } });
            }
        };
        getCategoryList()

        // 前回描画時の値を反映
        if (industryData) {
            setClassification(industryData.classification)
            setMainCategory(industryData.mainCategory)
            setSubCategory(industryData.subCategory)
            setItem(industryData.item)
            setItemFlg(industryData.itemFlg)
            setScaleCode(industryData.scaleCode)
            setSearchScaleCode(industryData.searchScaleCode)
            setSelectedL(industryData.selectedL)
            setSelectedM(industryData.selectedM)
            setSelectedS(industryData.selectedS)
            setSelectedF(industryData.selectedF)
            setSelectedSearch(industryData.selectedSearch)
            setSelectedRadio(industryData.selectedRadio)
            setText(industryData.text)
            if (industryData.selectedRadio === "option2") {
                handleSearch(industryData.text)
            }
        }
    }, [isOpen]);

    useEffect(() => {
        const getsubCategoryList = async () => {
            // セッションの有効性確認
            if (await sessionDisconnectedCheck(screenId, "getsubCategoryList", yearEdition, navigate)) {
                return
            }
            try {
                if ((selectedL == "")) {
                    return;
                }
                let allItems: any[] = [];
                let nextToken: string | null = null;
                do {
                    const client = generateClient();
                    const result: any = await client.graphql({
                        query: industryMastersByItem,
                        variables: {
                            item: 'blank',
                            nextToken: nextToken,
                            filter: {
                                and: [
                                    { startDateTime: { le: nowDate } },
                                    { endDateTime: { ge: nowDate } },
                                    { mainCategory: { eq: mainCategory } },
                                    { subCategory: { ne: 'blank' } },
                                    { scaleCode: { eq: searchScaleCode } }
                                ]
                            },
                            limit: 1000
                        },
                    });
                    const items = result.data?.industryMastersByItem?.items || [];
                    nextToken = result.data?.industryMastersByItem?.nextToken || null;
                    allItems = allItems.concat(items)
                } while (nextToken)
                allItems.sort((a: any, b: any) => {
                    //　中分類でソート
                    if (a.subCategory !== b.subCategory) {
                        return a.subCategory.localeCompare(b.subCategory);
                    }
                    // 中分類が同じ場合は規模コードでソート
                    if (a.scaleCode === "blank") return -1;
                    if (b.scaleCode === "blank") return 1;
                    return a.scaleCode.localeCompare(b.scaleCode);
                });
                setSubCategoryList(allItems)
            } catch (err) {
                navigate("/Error", { state: { title: SystemErrorTitle, message: SystemErrorMsg } });
            }
        };
        getsubCategoryList()
    }, [selectedL]);

    useEffect(() => {
        if (selectedM == "") {
            return;
        }
        const getSubSubCategoryList = async () => {
            // セッションの有効性確認
            if (await sessionDisconnectedCheck(screenId, "getSubSubCategoryList", yearEdition, navigate)) {
                return
            }
            try {
                let allItems: any[] = [];
                let nextToken: string | null = null;
                do {
                    const client = generateClient();
                    const result: any = await client.graphql({
                        query: industryMastersByItemFlg,
                        variables: {
                            itemFlg: '0',
                            nextToken: nextToken,
                            filter: {
                                and: [
                                    { startDateTime: { le: nowDate } },
                                    { endDateTime: { ge: nowDate } },
                                    { mainCategory: { eq: mainCategory } },
                                    { subCategory: { eq: subCategory } },
                                    { item: { ne: "blank" } }
                                ]
                            },
                            limit: 1000
                        },
                    });
                    const items = result.data?.industryMastersByItemFlg?.items || [];
                    nextToken = result.data?.industryMastersByItemFlg?.nextToken || null;
                    allItems = allItems.concat(items)
                } while (nextToken)
                allItems.sort((a: any, b: any) => {
                    //　小・細分類でソート
                    if (a.item !== b.item) {
                        return a.item.localeCompare(b.item);
                    }
                    //小・細分類が同じ場合は規模コードでソート
                    if (a.scaleCode === "blank") return -1;
                    if (b.scaleCode === "blank") return 1;
                    return a.scaleCode.localeCompare(b.scaleCode);
                });
                setSubSubCategoryList(allItems)
            } catch (err) {
                navigate("/Error", { state: { title: SystemErrorTitle, message: SystemErrorMsg } });
            }
        };
        getSubSubCategoryList()

    }, [selectedM]);

    useEffect(() => {
        if (selectedS == "") {
            return;
        }
        const getDetailLevelList = async () => {
            // セッションの有効性確認
            if (await sessionDisconnectedCheck(screenId, "getDetailLevelList", yearEdition, navigate)) {
                return
            }
            try {
                let allItems: any[] = [];
                let nextToken: string | null = null;
                do {
                    const client = generateClient();
                    const result: any = await client.graphql({
                        query: industryMastersByItemFlg,
                        variables: {
                            itemFlg: '1',
                            nextToken: nextToken,
                            filter:
                            {
                                and:
                                    [
                                        { startDateTime: { le: nowDate } },
                                        { endDateTime: { ge: nowDate } },
                                        { mainCategory: { eq: mainCategory } },
                                        { subCategory: { eq: subCategory } },
                                        { item: { beginsWith: item.slice(0, 3) } }
                                    ]
                            },
                            limit: 1000
                        },
                    });
                    const items = result.data?.industryMastersByItemFlg?.items || [];
                    nextToken = result.data?.industryMastersByItemFlg?.nextToken || null;
                    allItems = allItems.concat(items)
                } while (nextToken)
                allItems.sort((a: any, b: any) => {
                    //　小・細分類でソート
                    if (a.item !== b.item) {
                        return a.item.localeCompare(b.item);
                    }
                    //小・細分類が同じ場合は規模コードでソート
                    if (a.scaleCode === "blank") return -1;
                    if (b.scaleCode === "blank") return 1;
                    return a.scaleCode.localeCompare(b.scaleCode);
                });
                setDetailLevelList(allItems)
            } catch (err) {
                navigate("/Error", { state: { title: SystemErrorTitle, message: SystemErrorMsg } });
            }
        };
        getDetailLevelList()
    }, [selectedS]);

    const handleClearAll = () => {
        setSelectedL("")
        setSelectedM("")
        setSelectedS("")
        setSelectedF("")
        setSelectedSearch("")
        setClassification("")
        setText("")
        setSubCategoryList([])
        setSubSubCategoryList([])
        setDetailLevelList([])
        setFilteredResult([])
    }

    const handleClearType = () => {
        setSelectedL("")
        setSelectedM("")
        setSelectedS("")
        setSelectedF("")
        setClassification("")
    }

    const handleClearSearch = () => {
        setSelectedSearch("")
        setClassification("")
        setText("")
        setFilteredResult([])
    }
    const handleMainCategoryChange = (e: SelectChangeEvent) => {
        setSelectedL(e.target.value)
        const setListL = mainCategoryList.find((item) => item.id == e.target.value)
        setMainCategory(setListL != undefined ? setListL.mainCategory : "")
        setScaleCode(setListL != undefined ? setListL.scaleCode : "")
        setSearchScaleCode(setListL != undefined ? setListL.scaleCode : "")
        setClassification("大分類")
        setSubCategory("")
        setItem("")
        setItemFlg("")
        setSelectedM("")
        setSelectedS("")
        setSelectedF("")
    }

    const handleSubCategoryChange = (e: SelectChangeEvent) => {
        setSelectedM(e.target.value)
        const setListM = subCategoryList.find((item) => item.id == e.target.value)
        setSubCategory(setListM != undefined ? setListM.subCategory : "blank")
        setScaleCode(setListM != undefined ? setListM.scaleCode : searchScaleCode)
        setSearchScaleCode(setListM != undefined ? setListM.scaleCode : searchScaleCode)
        setClassification(setListM != undefined ? "中分類" : "大分類")
        setItem("")
        setItemFlg("")
        setSelectedS("")
        setSelectedF("")
    }

    const handleSubSubCategoryChange = (e: SelectChangeEvent) => {
        setSelectedS(e.target.value)
        const setListS = subSubCategoryList.find((item) => item.id == e.target.value)
        setItem(setListS != undefined ? setListS.item : "")
        setScaleCode(setListS != undefined ? setListS.scaleCode : "")
        setClassification(setListS != undefined ? "小分類" : "中分類")
        setItemFlg("")
        setSelectedF("")
    }

    const handleDetailLevelChange = (e: SelectChangeEvent) => {
        setSelectedF(e.target.value)
        const setListF = detailLevelList.find((item) => item.id == e.target.value)
        setItem(setListF != undefined ? setListF.item : "")
        setScaleCode(setListF != undefined ? setListF.scaleCode : "")
        setClassification(setListF! != undefined ? "細分類" : "小分類")
    }

    const handleSearchChange = async (e: SelectChangeEvent) => {
        setSelectedSearch(e.target.value)
        const setListSearch = filteredResult.find((item) => item.id == e.target.value)
        setMainCategory(setListSearch != undefined ? setListSearch.mainCategory : "")
        setScaleCode(setListSearch != undefined ? setListSearch.scaleCode : "")
        setSubCategory(setListSearch != undefined ? setListSearch.subCategory : "")
        setItem(setListSearch != undefined ? setListSearch.item : "")
        if (setListSearch == undefined) {
            setClassification("")
        } else if (setListSearch.mainCategory != "blank" && setListSearch.subCategory == "blank") {
            setClassification("大分類")
        } else if (setListSearch.subCategory != "blank" && setListSearch.item == "blank") {
            setClassification("中分類")
        } else if (setListSearch.item != "blank" && setListSearch.itemFlg == "0") {
            setClassification("小分類")
        } else if (setListSearch.item != "blank" && setListSearch.itemFlg == "1") {
            setClassification("細分類")
        };
    }

    const handleSearch = async (searchKeyword: string) => {
        if (text) {
            setLoading(true)
        }
        if (searchKeyword == "") {
            swal.fire({
                title: '業種選択',
                text: 'キーワードを入力してください',
                icon: 'error',
                confirmButtonText: 'OK',
                confirmButtonColor: '#01CFBE',
            });
        } else {
            // セッションの有効性確認
            if (await sessionDisconnectedCheck(screenId, "handleSearch", yearEdition, navigate)) {
                return
            }
            try {
                let allItems: any[] = [];
                let nextToken: string | null = null;
                do {
                    const client = generateClient();
                    const result: any = await client.graphql({
                        query: listIndustryMasters,
                        variables: {
                            limit: 1000,
                            nextToken: nextToken,
                            filter: {
                                and: [
                                    { startDateTime: { le: nowDate } },
                                    { endDateTime: { ge: nowDate } },
                                    { searchName: { contains: searchKeyword } },
                                ]
                            }
                        }
                    });
                    const item = result.data?.listIndustryMasters?.items || [];
                    nextToken = result.data?.listIndustryMasters?.nextToken || null;
                    allItems = allItems.concat(item)
                } while (nextToken)
                allItems.sort((a: any, b: any) => {
                    //　大分類でソート
                    if (a.mainCategory !== b.mainCategory) {
                        return a.mainCategory.localeCompare(b.mainCategory);
                    }
                    //　中分類でソート
                    if (a.subCategory !== b.subCategory) {
                        if (a.subCategory === "blank") return -1;
                        if (b.subCategory === "blank") return 1;
                        return a.subCategory.localeCompare(b.subCategory);
                    }
                    //　小・細分類でソート
                    if (a.item !== b.item) {
                        if (a.item === "blank") return -1;
                        if (b.item === "blank") return 1;
                        return a.item.localeCompare(b.item);
                    }
                    //各分類が同じ場合は規模コードでソート
                    if (a.scaleCode === "blank") return -1;
                    if (b.scaleCode === "blank") return 1;
                    return a.scaleCode.localeCompare(b.scaleCode);
                });
                setFilteredResult(allItems)
                setLoading(false)
            } catch (err) {
                navigate("/Error", { state: { title: SystemErrorTitle, message: SystemErrorMsg } });
            }
        }
    }

    const handleConfirm = () => {
        if (selectedL == "" && selectedSearch == "") {
            swal.fire({
                title: '業種選択',
                text: '業種を選択してください',
                icon: 'error',
                confirmButtonText: 'OK',
                confirmButtonColor: '#01CFBE',
            });
        } else {
            let selectIndustry: any = {}
            if (selectedF) {
                selectIndustry = detailLevelList.find((item) => item.id == selectedF)
            } else if (selectedS) {
                selectIndustry = subSubCategoryList.find((item) => item.id == selectedS)
            } else if (selectedM) {
                selectIndustry = subCategoryList.find((item) => item.id == selectedM)
            } else {
                selectIndustry = mainCategoryList.find((item) => item.id == selectedL)
            }
            if (selectedSearch) {
                selectIndustry = filteredResult.find((item) => item.id == selectedSearch)
            }
            const industryData: industryData = {
                industryName: selectIndustry.industryName,
                classification: classification,
                mainCategory: mainCategory,
                subCategory: subCategory,
                item: item,
                itemFlg: itemFlg,
                scaleCode: scaleCode,
                searchScaleCode: searchScaleCode,
                selectedL: selectedL,
                selectedM: selectedM,
                selectedS: selectedS,
                selectedF: selectedF,
                selectedSearch: selectedSearch,
                selectedRadio: selectedRadio,
                text: text,
            }
            onConfirm(industryData)

            // 各項目を初期化
            setSelectedL("")
            setSelectedM("")
            setSelectedS("")
            setSelectedF("")
            setText("")
            setSelectedSearch("")
            setMainCategory("")
            setSubCategory("")
            setItem("")
            setItemFlg("")
            setScaleCode("")
            setSearchScaleCode("")
            setClassification("")
            setSelectedRadio("option1")
            setFilteredResult([])
        }
    }

    const onClickHandleLink = () => {
        window.open("https://www.tsr-net.co.jp/static/sme-indicators/help/index.html", '_blank');
    }

    React.useEffect(() => {
        setOpen(isOpen)
    }, [isOpen])

    return (
        <>
            <BackdropLoading open={loading} />
            <Modal
                open={open}
                onClose={handleCloseModal}
                closeAfterTransition
            >
                <Fade in={open}>
                    <Box sx={modalStyle}>
                        <ModalLabel>
                            業種選択
                            <IconButton onClick={handleCloseModal} sx={{ position: 'absolute', top: '1px', right: '1rem' }}>
                                <CloseIcon style={{ color: '#fff' }} />
                            </IconButton>
                        </ModalLabel>
                        <Box sx={{ textAlign: 'right', marginRight: '1rem' }}>
                            <HelpButton variant="contained" color="secondary" onClick={onClickHandleLink}>ヘルプ</HelpButton>
                        </Box>

                        <Grid fontWeight={'350'}>
                            分類、または文字列から業種を指定してください。
                        </Grid>
                        <div>
                            <Box display="flex" gap={3} alignItems="center" sx={{ justifyContent: "center", alignItems: "center" }}>
                                <SearchGrid01>
                                    <RadioGroup row value={selectedRadio} onChange={(e) => setSelectedRadio(e.target.value)} style={{ width: '100%', marginBottom: '1rem' }}>
                                        <Grid size={{xs:3, sm:6, md:12}}>
                                            <Box key="radio1" display="flex" alignItems="center" sx={{ marginLeft: {xs:'3rem', sm: '4rem', md: '8rem'} }}>
                                                <FormControlLabel value="option1" control={<Radio color='default' />} label="" sx={{ marginRight: '-0.5rem' }} onClick={handleClearSearch} />
                                                <Box sx={{fontSize: 'clamp(0.8rem, 1.5vw, 1.1rem)'}}>分類から指定</Box>
                                            </Box>
                                        </Grid>
                                    </RadioGroup>
                                    <Grid size={5} sx={{ marginTop: '-1rem' }}>
                                        <TextFieldBox border={1} sx={{ height: '2rem', overflow: 'visible' }}>
                                            <TextFieldLabel sx={{ height: '2rem', minWidth: '24%' }}>大分類</TextFieldLabel>
                                            <Select disabled={selectedRadio != 'option1'} sx={{ width: '76%', height: '2.0rem', textAlign: 'left', backgroundColor: "#fff", borderRadius: '0' }} value={selectedL} onChange={handleMainCategoryChange} displayEmpty>
                                                <MenuItem key={undefined} value={""}>
                                                    <div style={{ color: '#d3d3d3' }}>大分類を選択</div>
                                                </MenuItem>
                                                {mainCategoryList.map((item) => (
                                                    <MenuItem key={item.id} value={item.id}>
                                                        {item.searchName}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </TextFieldBox>
                                    </Grid>
                                    {selectedL && subCategoryList.length != 0 &&
                                        <>
                                            <Grid>
                                                <DropDownIcon style={{ color: '#BFBFBF', fontSize: '5rem', margin: '-1.5rem' }} />
                                            </Grid>
                                            <Grid size={5} style={{ marginTop: '-0.4rem' }}>
                                                <TextFieldBox border={1} sx={{ height: '2rem', alignItems: 'center' }}>
                                                    <TextFieldLabel sx={{ height: '2rem', minWidth: '24%' }}>中分類</TextFieldLabel>
                                                    <Select disabled={selectedRadio != 'option1'} sx={{ width: '76%', height: '2.0rem', textAlign: 'left', backgroundColor: "#fff", borderRadius: '0' }} value={selectedM} onChange={handleSubCategoryChange} displayEmpty>
                                                        <MenuItem sx={{ maxWidth: '20.5rem' }} key={undefined} value={""}>
                                                            <div style={{ color: '#d3d3d3' }}>中分類を選択</div>
                                                        </MenuItem>
                                                        {subCategoryList.map((item) => (
                                                            <MenuItem key={item.id} value={item.id}>
                                                                {item.searchName}
                                                            </MenuItem>
                                                        ))}
                                                    </Select>
                                                </TextFieldBox>
                                            </Grid>
                                        </>
                                    }
                                    {selectedM && subSubCategoryList.length != 0 &&
                                        <>
                                            <Grid>
                                                <DropDownIcon style={{ color: '#BFBFBF', fontSize: '5rem', margin: '-1.5rem' }} />
                                            </Grid>
                                            <Grid size={5} style={{ marginTop: '-0.4rem' }}>
                                                <TextFieldBox border={1} sx={{ height: '2rem', alignItems: 'center' }}>
                                                    <TextFieldLabel sx={{ height: '2rem', minWidth: '24%' }}>小分類</TextFieldLabel>
                                                    <Select disabled={selectedRadio != 'option1'} sx={{ width: '76%', height: '2.0rem', textAlign: 'left', backgroundColor: "#fff", borderRadius: '0' }} value={selectedS} onChange={handleSubSubCategoryChange} displayEmpty>
                                                        <MenuItem key={undefined} value={""}>
                                                            <div style={{ color: '#d3d3d3' }}>小分類を選択</div>
                                                        </MenuItem>
                                                        {subSubCategoryList.map((item) => (
                                                            <MenuItem key={item.id} value={item.id}>
                                                                {item.searchName}
                                                            </MenuItem>
                                                        ))}
                                                    </Select>
                                                </TextFieldBox>
                                            </Grid>
                                        </>
                                    }
                                    {selectedS && detailLevelList.length != 0 &&
                                        <>
                                            <Grid>
                                                <DropDownIcon style={{ color: '#BFBFBF', fontSize: '5rem', margin: '-1.5rem' }} />
                                            </Grid>
                                            <Grid size={5} style={{ marginTop: '-0.4rem' }}>
                                                <TextFieldBox border={1} sx={{ height: '2rem', alignItems: 'center' }}>
                                                    <TextFieldLabel sx={{ height: '2rem', minWidth: '24%' }}>細分類</TextFieldLabel>
                                                    <Select disabled={selectedRadio != 'option1'} sx={{ width: '76%', height: '2.0rem', textAlign: 'left', backgroundColor: "#fff", borderRadius: '0' }} value={selectedF} onChange={handleDetailLevelChange} displayEmpty>
                                                        <MenuItem key={undefined} value={""}>
                                                            <div style={{ color: '#d3d3d3' }}>細分類を選択</div>
                                                        </MenuItem>
                                                        {detailLevelList.map((item) => (
                                                            <MenuItem key={item.id} value={item.id}>
                                                                {item.searchName}
                                                            </MenuItem>
                                                        ))}
                                                    </Select>
                                                </TextFieldBox>
                                            </Grid>
                                        </>
                                    }
                                </SearchGrid01>
                                <SearchGrid02>
                                    <RadioGroup row value={selectedRadio} onChange={(e) => setSelectedRadio(e.target.value)} style={{ width: '100%', marginBottom: '1rem' }}>
                                        <Grid size={3}>
                                            <Box key="radio2" display="flex" alignItems="center" sx={{ marginLeft: {xs:'3rem', sm: '4rem', md: '8rem'} }}>
                                                <FormControlLabel value="option2" control={<Radio color='default' />} label="" sx={{ marginRight: '-0.5rem' }} onClick={handleClearType} />
                                                <Box sx={{fontSize: 'clamp(0.8rem, 1.3vw, 1.1rem)'}}>文字列から指定</Box>
                                            </Box>
                                        </Grid>
                                    </RadioGroup>
                                    <Grid size={5} style={{ marginTop: '-1rem' }}>
                                        <Stack direction={'row'} spacing={1}>
                                            <TextFieldBox sx={{ width: '18rem', minWidth:'7rem', height: '2rem' }} border={1}>
                                                <Grid container>
                                                    <TextFieldForm sx={{ width: '18rem', minWidth:'7rem' }}>
                                                        <DataInputForm disabled={selectedRadio != "option2"} value={text} onChange={(e) => setText(e.target.value)} placeholder="フリーワードを入力" fullWidth variant='outlined' size='small' />
                                                    </TextFieldForm>
                                                </Grid>
                                            </TextFieldBox>
                                            <Comparisonbutton variant="contained" color="secondary" onClick={() => handleSearch(text)}><SearchIcon style={{ marginRight: 'rem', color: '#41DBCE', marginLeft: '-0.5rem' }} />検索</Comparisonbutton>
                                        </Stack>
                                    </Grid>
                                    <Grid>
                                        <DropDownIcon style={{ color: '#BFBFBF', fontSize: '5rem', margin: '-1rem' }} />
                                    </Grid>
                                    <Grid size={5}>
                                        <TextFieldBox sx={{ height: '2rem', alignItems: 'center' }} border={1}>
                                            <FormControl fullWidth>
                                                <Grid container>

                                                    <Select fullWidth disabled={selectedRadio != 'option2'} sx={{ width: '100%', height: '2.0rem', textAlign: 'left', backgroundColor: "#fff", borderRadius: '0' }} value={selectedSearch} onChange={handleSearchChange} displayEmpty>
                                                        <MenuItem key={undefined} value={""}>
                                                            <div style={{ color: '#d3d3d3' }}>検索結果</div>
                                                        </MenuItem>
                                                        {filteredResult.map((item) => (
                                                            <MenuItem key={item.id} value={item.id}>
                                                                {item.stringSearchName}
                                                            </MenuItem>
                                                        ))}
                                                    </Select>
                                                </Grid>
                                            </FormControl>
                                        </TextFieldBox>
                                    </Grid>
                                </SearchGrid02>
                            </Box>
                        </div>
                        <Box sx={{ marginTop: '1.2rem' }}>
                            <AppliedButton variant="contained" color="secondary" onClick={handleConfirm}>確定</AppliedButton>
                            <div>
                                <Button sx={{ color: 'black', fontSize: '1rem', fontWeight: '300', marginTop: '0.5rem' }} onClick={handleClearAll}>
                                    クリア
                                </Button>
                            </div>
                        </Box>
                    </Box>
                </Fade>
            </Modal>
        </>
    );
}

export default SelectIndustryModal;
